module.exports = __webpack_public_path__ + "0de3b51742ed3ac61435875bccd8973b.png";